import * as angular from "angular";

export class DocumentService {
    private $http: any;
    private apiRoot: string;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/document";
    }

    query(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all", data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/delete/" + data.id, data);
    }

    get_url(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/getURL/" + data.id, data);
    }

    get_data(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/getData/" + data.id, data);
    }
}
angular.module("vcServices").service("DocumentService", DocumentService);
